// extracted by mini-css-extract-plugin
export default {"container":"PublicChangePassword_container__YSDz5"};